import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import LoginPage from './pages/loginPage';
import RegisterForm from './pages/RegisterPage';
import Home from './pages/Home';
import AboutUs from './pages/Aboutus';  
import Gallery from './pages/Gallery';
import Leadership from './pages/Leadership';
import Membership from './pages/Membership';
import LandingPage from './pages/Landingpage';
import { AuthProvider } from './context/AuthContext'; 
import Profile from './pages/profilepage';
import Paymentgateway1 from "./pages/Paymentgateway1";
import Paymentgateway2 from "./pages/Paymentgateway2";
import Manageusers from './pages/Managusers';
import Manageuser from './pages/Manageuser';
import Userprofile from './pages/Userprofile';
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Whatsnext from "./pages/Whatsnext";
import Help from "./pages/Help";
import Receipt from "./pages/Receipt";
import ProtectedRoute from "./components/ProtectedRoute";
import { GlobalStyles } from '@mui/material';

import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { AnimatePresence } from "framer-motion";
import PageWrapper from "./components/PageWrapper"; 
import ChangePassword from "./components/ChangePassword"; 
import WorkInProgress from "./components/WorkInProgress"; 
// import the wrapper
import Profilepage from "./pages/profile";// import the wrapper

const theme = createTheme({
  typography: {
    fontFamily: "Poppins, sans-serif",
  },
});

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrapper><Home /></PageWrapper>} />
        <Route path="/login" element={<PageWrapper><LoginPage /></PageWrapper>} />
        <Route path="/register" element={<PageWrapper><RegisterForm /></PageWrapper>} />
        <Route path="/aboutus" element={<PageWrapper><AboutUs /></PageWrapper>} />
        <Route path="/gallery" element={<PageWrapper><Gallery /></PageWrapper>} />
        <Route path="/leadership" element={<PageWrapper><Leadership /></PageWrapper>} />
        <Route path="/landing" element={<PageWrapper><LandingPage /></PageWrapper>} />
        <Route path="/terms" element={<PageWrapper><Terms /></PageWrapper>} />
        <Route path="/privacy" element={<PageWrapper><Privacy /></PageWrapper>} />
        <Route path="/whatsnext" element={<PageWrapper><Whatsnext /></PageWrapper>} />
        <Route path="/help" element={<PageWrapper><Help /></PageWrapper>} />
        <Route path="/wip" element={<PageWrapper><WorkInProgress /></PageWrapper>} />

        {/* Protected Routes */}
        <Route path="/profile" element={
          <ProtectedRoute allowedRoles={['admin', 'user', 'superuser']}>
            <PageWrapper><Profile /></PageWrapper>
          </ProtectedRoute>
        } />
        <Route path="/paymentgateway" element={
          <ProtectedRoute allowedRoles={['admin', 'user', 'superuser']}>
            <PageWrapper><Paymentgateway1 /></PageWrapper>
          </ProtectedRoute>
        } />
        <Route path="/paymentgateway2" element={
          <ProtectedRoute allowedRoles={['admin', 'user', 'superuser']}>
            <PageWrapper><Paymentgateway2 /></PageWrapper>
          </ProtectedRoute>
        } />
        <Route path="/manageusers" element={
          <ProtectedRoute allowedRoles={['admin', 'superuser']}>
            <PageWrapper><Manageusers /></PageWrapper>
          </ProtectedRoute>
        } />
        <Route path="/manageuser" element={
          <ProtectedRoute allowedRoles={['admin', 'superuser']}>
            <PageWrapper><Manageuser /></PageWrapper>
          </ProtectedRoute>
        } />
        <Route path="/membership" element={
          <ProtectedRoute allowedRoles={['admin', 'user', 'superuser']}>
            <PageWrapper><Membership /></PageWrapper>
          </ProtectedRoute>
        } />
        <Route path="/change-password" element={
          <ProtectedRoute allowedRoles={['admin', 'user', 'superuser']}>
            <PageWrapper><ChangePassword /></PageWrapper>
          </ProtectedRoute>
        } />
        <Route path="/userprofile" element={
          <ProtectedRoute allowedRoles={['admin', 'superuser']}>
            <PageWrapper><Userprofile /></PageWrapper>
          </ProtectedRoute>
        } />
        <Route path="/receipt" element={
          <ProtectedRoute allowedRoles={['admin', 'user', 'superuser']}>
            <PageWrapper><Receipt /></PageWrapper>
          </ProtectedRoute>
        } />
        <Route path="/completemyprofile" element={
          <ProtectedRoute
            allowedRoles={['admin', 'user', 'superuser']}
            condition={(user) => !user.profileCompleted} // Only allow if profile is NOT completed
            redirectTo="/profile" // Redirect to profile if already completed
          >
            <PageWrapper><Profilepage /></PageWrapper>
          </ProtectedRoute>
        } />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    
    <ThemeProvider theme={theme}>
      <CssBaseline />
     <GlobalStyles
        styles={{
          '.MuiAutocomplete-paper': {
            backgroundColor: '#f8f9e9', 
          },
          '.MuiAutocomplete-option:hover': {
            backgroundColor: '#eeeeee', 
          },
          '.MuiAutocomplete-option[aria-selected="true"]': {
            backgroundColor: '#e0e0e0', 
          },
        }}
      />

      <AuthProvider>
        <Router>
          <div className="App">
            <Header />
            <AnimatedRoutes />
            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
